module.exports = __webpack_public_path__ + "static/img/Dale-Finucane.854aed9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dale-Finucane.jpg
// module id = Skuc
// module chunks = 0